/**
 * CanvasRow — layout container. Provides the `canvas` slot. Hosts
 * `canvas.*` painter children (canvas.hrule, canvas.points,
 * canvas.regression-curve, …).
 *
 * Owns axis configuration (xAxis, yAxis, xPadding) — stored in the
 * row's `attributes` bag under the `canvas` key.
 */
import type { Option } from "../../core/option.ts";
import { Json } from "../../core/json.ts";
import { CanvasConfig } from "../descriptor.ts";
import { LayoutRow } from "./layout-row.ts";

/**
 * The `canvas` layout row: hosts `canvas.*` painter children and owns the canvas's axis
 * configuration.
 */
export class CanvasRow extends LayoutRow {
  /** Axis configuration for this canvas. */
  get canvasConfig(): Option<CanvasConfig> {
    return CanvasConfig.decode(Json.child(this.attributes(), "canvas"));
  }
}
